import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Heading } from "../../../common/Heading/Heading";
import { ConversationMessages } from "./ConversationMessages/ConversationMessages";
import { AnswerDetailsView } from "../../../common/AnswerDetailsView/AnswerDetailsView";
import { TitleSection } from "./AnswerDetails.styles";
import { useAnswerLogData } from "../../../../hooks/useAnswerLogData";

export const AnswerDetails = () => {
  const { answerId } = useParams();
  const { t, i18n } = useTranslation();
  const { isLoadingAnswerLogs, error, conversationData, info, logsData } =
    useAnswerLogData(answerId);

  const conversationComponent = (
    <ConversationMessages conversationData={conversationData} t={t} />
  );

  const headerContent = (
    <TitleSection>
      <Heading
        text={
          i18n.language === "ru" ? `Ответ ${answerId}` : `Answer ${answerId}`
        }
        size={1}
      />
    </TitleSection>
  );

  return (
    <AnswerDetailsView
      conversationComponent={conversationComponent}
      summary={info.summary}
      question={info.question}
      answer={info.answer}
      sources={info.sources}
      product={info.product}
      macrosSuggestions={info.macros_suggestions}
      selectedMacroId={info.selected_macro_id}
      selectedMacroSource={info.selected_macro_source}
      selectedMacro={info.selected_macro}
      logsData={logsData}
      isLoading={isLoadingAnswerLogs}
      error={error}
      errorInfo={info.error}
      successStatus={info.success_status}
      children={headerContent}
    />
  );
};
